import { getPaddingString } from "../parser/utils";

export default ({ data, id }) => {
  const { html, contentID } = data;
  return `
    <div id="${contentID || id}" style="${getPaddingString(data)};">
      ${html}
    </div>
  `;
};
